/* src/app/admin/tenant/create-or-update-tenant.component.scss */
.section-margin-top {
  margin-top: 40px;
}
.switch-container {
  display: flow;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 24px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 24px;
  transition: background-color 0.4s ease;
}
.slider:before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.4s ease;
  z-index: 2;
}
/*# sourceMappingURL=create-or-update-tenant.component-JJE5CHSL.css.map */
